module.exports = __webpack_public_path__ + "static/media/ic-three-lines.68d6f526.svg";